'use strict';

var React = require('react');

var SvgReceiptPoundIcon = function SvgReceiptPoundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5a1.75 1.75 0 0 0-1.75 1.75v2h-.75a.75.75 0 0 0 0 1.5h.75v1.5h-.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-2.25v-1.5h.75a.75.75 0 0 0 0-1.5h-.75v-2a.25.25 0 0 1 .25-.25h.75v1a.75.75 0 0 0 1.5 0v-1.25c0-.69-.56-1.25-1.25-1.25h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 16a1.5 1.5 0 0 0 2.615 1.003l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.23 0l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.615-1.003v-11a2.5 2.5 0 0 0-2.5-2.5h-7a2.5 2.5 0 0 0-2.5 2.5v11Zm8.149-2h.203a.995.995 0 0 1 .641.326l1.507 1.674v-11a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v11l1.507-1.674a.995.995 0 0 1 .641-.326h.204a.995.995 0 0 1 .641.326l1.507 1.674 1.507-1.674a.995.995 0 0 1 .642-.326Z"
  }));
};
SvgReceiptPoundIcon.displayName = "ReceiptPoundIcon";

exports.SvgReceiptPoundIcon = SvgReceiptPoundIcon;
